import { render, staticRenderFns } from "./pdf-js.vue?vue&type=template&id=763eb1ae&scoped=true&"
import script from "./pdf-js.vue?vue&type=script&lang=js&"
export * from "./pdf-js.vue?vue&type=script&lang=js&"
import style0 from "./pdf-js.vue?vue&type=style&index=0&id=763eb1ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763eb1ae",
  null
  
)

export default component.exports